
























import { computed, defineComponent } from '@vue/composition-api';
import { StatusState } from '@/store/types';

const statusOptions: Array<{ value: StatusState; label: string }> = [
	{ value: 'posted', label: 'Posted' },
	{ value: 'stratified', label: 'Stratified' },
	{ value: 'sampled', label: 'Sampled' },
];

export default defineComponent({
	emits: ['ok'],
	props: {
		useDesktopLayout: {
			type: Boolean,
			default: false,
		},
	},
	setup(_, { root }) {
		const statusFilter = computed({
			get: () => root.$store.getters['fieldsView/getStatusFilter'],
			set: (value: StatusState) => root.$store.dispatch('fieldsView/setStatusFilter', value),
		});

		const clearFilter = () => {
			root.$store.dispatch('fieldsView/setStatusFilter', null);
		};

		return {
			statusFilter,
			clearFilter,
			statusOptions,
		};
	},
});
